import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import SearchBox from "../SearchBox";
import { useTranslation } from "react-i18next";
import Logo from "../../Assets/Images/cloudvidia_white.png";

import FilterContext from "../../Hooks/Context";
import LanguageDropdown from "../LanguageDropdown/LanguageDropdown";


const Header = (props) => {
  const {i18n, t} = useTranslation();

  const [menuStatus, SetMenuStatus] = useState(false);
  const filterQueries = useContext(FilterContext);
  const history = useHistory();

  const logout = () => {
    let rememberMe = localStorage.getItem("rememberMe");
    if (!rememberMe) {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("rememberMe");
    }
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    history.push("/");
  };

  return (
    <div className="row header">
      <div className="col-md-2 col-sm-12 logo-container">
        <div className="row">
          <div className="col-9">
            <img src={Logo} alt="logo" title="logo" />
          </div>
          <div className="col-3 hamburger-icon">
            <div
              id="nav-icon2"
              className={menuStatus ? "open" : ""}
              onClick={props.ToggleClass}
            >
              <label htmlFor="openSideMenu" className="menuIconToggle">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-10 col-sm-12 header">
        <div className="row">
          <div className="col-6" style={{paddingLeft: '20px'}}>
            <SearchBox />
          </div>
          <div className="col-6 text-right user-panel-wrapper">
            <div className="usergroup">
              <LanguageDropdown />
              <div className="user-panel">
                <div className="user-avatar">
                  <i className="fa fa-user" aria-hidden="true"></i>
                </div>
                <span className="username">
                  {t("LT_customer")}&nbsp;{" "}
                  <span className="logout" onClick={logout}>
                    <i className="fa fa-sign-out" aria-hidden="true" style={{'fontSize':'13pt'}}></i>
                  </span>{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
